import Highcharts from 'highcharts';

export const figure42 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height: '2000px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},
credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},
plotOptions: {
series: {
borderWidth: 0,
stacking: 'normal',
}
},
exporting: {
enabled: false
},
xAxis: [{
tickWidth: 0,
labels: {
groupedOptions: [{
	  style: {
			 transform: 'unset'
		 },
  }],
  style: {
			 transform: 'translateX(11px)'
		 },
		 align: 'right'
},
categories: [
{
name: "منطقة البحر الكاريبي",
categories: ["سانت لوسيا*","سانت فينسنت والغرينادين*", "جمهورية الدومنيكان*"]
},
{
name: "أمريكا اللاتينية",
categories: ["سانت لوسيا*", "سانت فينسنت والغرينادين*", "جمهورية الدومنيكان*", "‫بليز‬‬‬", "‫غيانا‬‬‬", "تشيلي", "‫سورينام‬‬‬", "الإكوادور", "المكسيك", "كوستاريكا", "الأوروغواي*", "البيرو", "باراغواي", "نيكاراغوا", "غواتيمالا", "بوليفيا (دولة - المتعددة القوميات)", "كولومبيا", "أمريكا الوسطى**", "أمريكا الجنوبية"]
},
{
name: "آسيا الوسطى وجنوب آسيا",
categories: ["باكستان", "أوزبكستان*", "‫نيبال‬*‬‬"]
},
{
name: "شرق وجنوب شرق آسيا",
categories: ["ميانمار", "تايلاند*", "منغوليا‬‬‬", "فيتنام‬", "كمبوديا^",]
},
{
name: "غرب آسيا",
categories: ["لبنان*", "فلسطين*", "اليمن*", "قطر*", "الأردن*", "تركيا*", "أذربيجان*", "أرمينيا*^", "جورجيا* ^ ", "غرب آسيا"]
},
{
name: "أفريقيا جنوب الصحراء",
categories: ["جيبوتي‬", "موريتانيا‬‬", "سيرا ليون", "غانا", "السنغال*", "‫النيجر‬", "مدغشقر", "زيمبابوي", "مالي", "ملاوي‬‬‬", "جمهورية أفريقيا الوسطى‬", "كوت ديفوار‬‬‬", "تشاد", "توجو", "ليبيريا‬‬‬", "ناميبيا", "أوغندا", "جمهورية تنزانيا المتحدة", "كينيا‬‬", "بنين", "أثيوبيا^", "رواندا^", "بوركينا فاسو"]
},
{
name: "",
categories: ["غرب أفريقيا**"]
},
{
name: "أوروبا",
categories: ["البوسنة والهرسك*", "بيلاروس*", "جمهورية مولدوفا* ", "سويسرا*", "ألمانيا*", "سلوفاكيا*", "شمال مقدونيا*", "الجبل الأسود‬* ", "إيطاليا", "السويد* ^", "صربيا*", "‫البرتغال‬‬‬", "هنغاريا* ^", "ليتوانيا* ^"]
},
{
name: "",
categories: ["البلدان غير الساحلية النامية"]
},
],
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
tickLength: 25,
}],
yAxis: [{
labels: {
  style: {
		 fontWeight: 'normal',
		 color: '#999999',
		 fontSize: '11px'
	 },
	},
	min: 0,
	max: 6,
	tickInterval: 1,	
format: '{value}%',
gridLineWidth: 1,
floor: 0,

title: {
  text: '',
  style: {
		color: Highcharts.getOptions().colors[1]
	}
}
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
valuePrefix: '',
style: {
  padding: 0
}
},
legend: {
enabled: false,
},

series: [{
name: '',
color: '#5b9bd5',
data: [
1,
2,
3,
1,
2,
2,
2,
3,
3,
3,
4,
5,
5,
5,
5,
5,
6,
3,
4,
2,
3,
4,
1,
4,
4,
4,
6,
1,
1,
1,
1,
1,
3,
3,
3,
5,
2,
1,
1,
1,
1,
2,
2,
2,
3,
3,
3,
3,
3,
4,
4,
4,
5,
5,
5,
5,
5,
6,
6,
6,
3,
3,
3,
3,
3,
4,
4,
4,
4,
4,
5,
5,
5,
5,
5,
4,
]
}]
}